import React, { useState } from "react";
import { Technologie } from "./AllTechnologie";
import "./tech.css";
import { AnimatePresence, motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";

const Tech = () => {
  return (
    <>
      <div>
        <h2 id="technologie" className="titleTechno text-center">
          TECHNOLOGIES{" "}
        </h2>
      </div>
      <Row className="image-container">
        {Technologie.map((item, index) => {
          return (
            <Col
              lg="2"
              md="4"
              sm="5"
              xs="6"
              key={index}
              className="d-flex align-items-center justify-content-center image-wrapper"
              itemScope
              itemType="http://schema.org/SoftwareApplication"
            >
              <img
                key={index}
                className="imgTechno"
                src={item.imgPath}
                itemprop="image"
              />
              <p className="image-name" itemprop="name">
                {item.title}
              </p>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default Tech;